export default "__VITE_ASSET__BDdfLA1o__"